import SymbolIcon from './SymbolIcon'
import './DateRangeField.css'

const PLACEHOLDER = 'TT.MM.JJJJ - TT.MM.JJJJ'

export default function DateRangeField({ start, end, formatDate, state = 'editable', onClick }) {
  const editable = state === 'editable'
  const value = start
    ? `${formatDate(start)} - ${end ? formatDate(end) : 'TT.MM.JJJJ'}`
    : PLACEHOLDER

  return (
    <button
      className={`date-range-field is-${state}`}
      type="button"
      onClick={editable ? onClick : undefined}
      disabled={!editable}
    >
      <span>{value}</span>
      <SymbolIcon icon="calendar_month" className="date-range-field__icon" />
    </button>
  )
}
